<wlm-tree-dropdown
  [settings]="props.settings"
  [treeNodes]="props.treeNodes"
  [selectedKeys]="selectedKeys"
  [disabled]="disabled"
  (selectedKeysChange)="onValueChanged($event)"
></wlm-tree-dropdown>
